export default __webpack_public_path__ + "static/media/HyperTubeStart.256.38e7b8ca.png";